export const DEFAULT_SNAPSHOT_DEBOUNCE_MS = 1000;
export const DEFAULT_HEARTBEAT_INTERVAL_MS = 60_000;
export const DEFAULT_HEARTBEAT_CHECK_INTERVAL_MS = 5_000;
export const DEFAULT_QUEUE_POLL_INTERVAL_MS = 500;
export const DEFAULT_HASH_BATCH_SIZE = 32;
export const DEFAULT_MAX_SNAPSHOT_ATTEMPTS = 5;
export const DEFAULT_HTTP_TIMEOUT_MS = 120_000;
export const DEFAULT_UPLOAD_CHUNK_SIZE = 1;
export const DEFAULT_MAX_QUERY_WAIT_MS = 50_000;
